import styled from 'styled-components';

export default styled.section`
  padding: 2rem ${props => props.theme.padding.inner};

  .inner {
    margin: auto;
    max-width: ${props => props.theme.maxWidths.containerSmall};
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      max-width: ${props => props.theme.maxWidths.container};
    }
  }

  .categories {
    position: relative;
    width: 50%;
    max-width: 250px;
    margin-left: 0.75rem;

    label {
      width: 100%;

      &.open {
        .values {
          max-height: 300px;
          border: solid 1px ${props => props.theme.colors.grey4};
          box-shadow: ${props => props.theme.shadows.high};
          margin: 0.25rem 0 0;
        }
      }
    }

    .input-dropdown_icon {
      right: 0;
    }

    .input_wrapper {
      button {
        position: relative;
        padding-right: 2rem;
      }
    }

    .input-value {
      font-size: ${props => props.theme.type.paragraph.default};
      line-height: ${props => props.theme.lineHeights.paragraph.default};
      letter-spacing: ${props => props.theme.letterSpacing.paragraph};
      color: ${props => props.theme.colors.grey1};
      margin: 0;
      padding: 0;
      cursor: pointer;
      border: none;
      background: transparent;
      display: flex;
      flex-direction: row;
      align-items: center;
      font-family: ${props => props.theme.fonts.primary};

      svg {
        margin-top: -0.15rem;
        margin-left: 0.5625rem;
        color: ${props => props.theme.colors.claytonBlue};
      }
    }

    .values {
      position: absolute;
      list-style: none;
      max-height: 0;
      overflow: hidden;
      margin: 0;
      padding: 0;
      background: ${props => props.theme.colors.white};
      z-index: 100;
      width: 181px;
      border: solid 1px transparent;
      border-radius: 4px;
      transition: all 0.4s ease-in-out;

      li {
        padding: 0;
        margin: 0;

        p {
          margin: 0;
          font-size: ${props => props.theme.type.caption.default};
          line-height: ${props => props.theme.lineHeights.caption.default};
          letter-spacing: ${props => props.theme.letterSpacing.caption};
        }
      }

      button {
        cursor: pointer;
        background: transparent;
        border: none;
        width: 100%;
        text-align: left;
        padding: 0.75rem 1.5rem;
        font-family: ${props => props.theme.fonts.primary};
        color: ${props => props.theme.colors.grey1};
      }
    }

    .input-error {
      position: absolute;
    }
  }

  .search {
    position: relative;
    width: 50%;
    max-width: 250px;
    margin-left: 2rem;

    .short-text {
      display: none;
      @media (max-width: ${props => props.theme.breakpoints.tablet}) {
        display: block
      }
    }

    .full-text {
      @media (max-width: ${props => props.theme.breakpoints.tablet}) {
        display: none;
      }
    }

    svg {
      position: absolute;
      right: 5px;
      top: 10%;
      z-index: -1;
      color: ${props => props.theme.colors.claytonBlue};
    }

    button {
      &:focus {
        outline: none;
      }

      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      background: transparent;
      border: none;
      cursor: pointer;
      z-index: 1;
      height: 100%;
      width: 30px;

      svg {
        path {
          fill: ${props => props.theme.colors.claytonBlue};
        }
      }
    }

    label {
      .input_wrapper {
        display: flex;
        justify-content: flex-end;
      }

      .input-label {
        position: absolute;
        opacity: 0;
      }

      &.filled {
        input {
           {
            width: 100%;
            border-bottom: solid 1px ${props => props.theme.colors.claytonBlue};
          }
        }
      }
    }

    input {
      cursor: auto;
      background: transparent;
      box-sizing: border-box;
      border: 1px solid #777B7E;
      font-size: ${props => props.theme.type.paragraph.intro};
      line-height: ${props => props.theme.lineHeights.paragraph.intro};
      letter-spacing: ${props => props.theme.letterSpacing.paragraph};
      width: 100%;
      padding: 0 1.5rem 0 .5rem;
      transition: all 0.4s ease-in-out;
      outline: none;
      height: 2rem;
      margin-bottom: .5rem;

      &::focus,
      &::active {
        width: 100%;
        border-bottom: solid 1px ${props => props.theme.colors.claytonBlue};
      }

      &::-ms-clear {
        width: 0;
        height: 0;
      }
    }

    .input-error {
      position: absolute;
    }
  }
`;
